import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import './index.scss';

const Layout = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        
        setTimeout(() => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    setIsLoaded(true);
                    document.documentElement.classList.add('force-repaint');

                    
                    const homeContainer = document.querySelector('.container.home-page');
                    if (homeContainer && homeContainer.getAnimations().length === 0) {
                        homeContainer.style.animation = 'fadeIn 1s forwards';
                        homeContainer.style.animationDelay = '1s';
                        
                        homeContainer.getBoundingClientRect(); 
                    }
                }, 16);
            });
        }, 0);
    }, []);

    useEffect(() => {
        return () => {
            document.documentElement.classList.remove('force-repaint');
        };
    }, []);

    return (
        <div className={`App ${isLoaded ? 'loaded' : ''}`}>
            <Sidebar />
            <div className="page">
                <span className="tags top-tags">&lt;body&gt;</span>
                <Outlet />
                <span className="tags bottom-tags">
                    &lt;/body&gt;
                    <br />
                    <span className="bottom-tag-html">&lt;/html&gt;</span>
                </span>
            </div>
        </div>
    );
};

export default Layout;